module.exports = __webpack_public_path__ + "img/logo.7893bb8a.png";